import React, { PropsWithChildren, useMemo } from 'react';
import { useSelector } from 'react-redux';
import UIButton from 'Components/UIComponents/UIButton';
import { PlanDetails } from 'Interfaces/Billing';
import { selectSubscriptionInfo, selectUserPlan } from 'Utils/selectors';

import {
  discountOrLess,
  financialReasonPeriodBySubscriptionOption,
} from './common/discountsData';

interface BillingCancelPlanWizardFinancialReasonProps {
  onCancel?: () => void;
  onSubmit?: () => void;
}

const BillingCancelPlanWizardFinancialReason = (
  props: PropsWithChildren<BillingCancelPlanWizardFinancialReasonProps>,
) => {
  const { children, onCancel, onSubmit } = props;

  const userPlan: PlanDetails = useSelector(selectUserPlan);
  const subscriptionInfo = useSelector(selectSubscriptionInfo);

  const period = useMemo(() => {
    return financialReasonPeriodBySubscriptionOption(userPlan?.duration);
  }, [userPlan]);

  const discount = useMemo(() => {
    return discountOrLess(subscriptionInfo.discountPercent, userPlan);
  }, [subscriptionInfo.discountPercent, userPlan]);

  return (
    <>
      <h1 className="billing__plan-cancel-modal-title">A Special offer just for you!</h1>
      <p className="billing__plan-cancel-modal-paragraph">
        We&apos;re offering you a {discount}% discount on our {period} plan, making it
        easier to enjoy all the benefits of Signaturely, like Unlimited Templates and
        Custom Branding, at a reduced price. Ready to save and continue seamlessly
        managing your documents?
      </p>
      {children}
      <div className="billing__plan-cancel-modal-actions">
        <UIButton
          priority="primary"
          title="Yes, I'm Interested"
          className="billing__plan-cancel-modal-button--primary"
          handleClick={onSubmit}
        />
        <UIButton
          priority="white"
          title="No, thank you"
          className="billing__plan-cancel-modal-button--white"
          handleClick={onCancel}
        />
      </div>
    </>
  );
};

export default BillingCancelPlanWizardFinancialReason;
